import { render, staticRenderFns } from "./NegociacaoLista.vue?vue&type=template&id=454c7810"
import script from "./NegociacaoLista.vue?vue&type=script&lang=js"
export * from "./NegociacaoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports